import { Container, VStack, Button, Heading, Text } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ListContextBanner } from './ListContextBanner'
import type { ReactNode } from 'react'

interface CanvassingPageShellProps {
  title: string
  subtitle: string
  children: ReactNode
}

export function CanvassingPageShell({ title, subtitle, children }: CanvassingPageShellProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const listId = searchParams.get('listId')

  const handleBackClick = () => {
    const backUrl = listId ? `/dashboard/canvassing?listId=${listId}` : '/dashboard/canvassing'
    navigate(backUrl)
  }

  return (
    <Container maxW="container.xl" py={8}>
      <VStack gap={6} align="stretch">
        <Button
          variant="ghost"
          alignSelf="flex-start"
          onClick={handleBackClick}
          size="sm"><FiArrowLeft />Back to Canvassing
                  </Button>

        <VStack align="stretch" gap={2}>
          <Heading size="lg">{title}</Heading>
          <Text color="gray.500">{subtitle}</Text>
        </VStack>

        {listId && <ListContextBanner listId={listId} />}

        {children}
      </VStack>
    </Container>
  );
}
